
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $T1bCI = parcelRequire("T1bCI");


var $3tMMZ = parcelRequire("3tMMZ");


var $gz8ZY = parcelRequire("gz8ZY");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $hDG7z = parcelRequire("hDG7z");

/**
 * @graphql cc
 */ 






var $diswb = parcelRequire("diswb");


var $jSnXV = parcelRequire("jSnXV");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $4VJDS = parcelRequire("4VJDS");


var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $42omo.useRef)(null);
    const allAppsLoaded = (0, $42omo.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const presetTimeoutConfig = (0, $4VJDS.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $4VJDS.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $diswb.useQuery)((0, $eSUdr.default)`query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id theme{themeKey}}}`, {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        }
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch && (0, $6mKj3.expVal)('confluence_remove_atlgeneral_height_timeout', 'isEnabled', false)) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch && (0, $6mKj3.expVal)('confluence_remove_atlgeneral_height_timeout', 'isEnabled', false)) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");



























var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $42omo.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
            if (entry) {
                document.documentElement.style.setProperty('--forge-page-banner-height', `${entry.target.clientHeight}px`);
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: entry.target.clientHeight
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};






var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $1DWH0 = parcelRequire("1DWH0");


var $9wGTI = parcelRequire("9wGTI");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $1DWH0.default)()(class ReturnToMobileComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1yt4pxbi _11q7i8nm _y3gn1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__enterprise-exp') ? // eslint-disable-next-line @atlassian/a11y/anchor-is-valid
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, @atlassian/a11y/anchor-is-valid
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", ()=>{
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $42omo.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");








var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");





var $jmjWc = parcelRequire("jmjWc");


const $727a4bb7ae4ee699$export$1584143957275f3b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qS8Rk",
    name: "FloatingNoteLayout",
    loader: async ()=>(await (parcelRequire("7fOZj"))).FloatingNoteLayout
});






var $9HB34 = parcelRequire("9HB34");

var $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db;
$ae6f1a0e4a2e28fc$export$da31f8cf16ec20db = `OsGcuW_dialogStyle`;









function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
};


const $4e0d0b830c02a893$export$7292bf0b169ba997 = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_1e0c1ule",
    hidePanel: "_1e0cglyw"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_v5641fl4 _2lx2vrvc _1n261g80 _1bsb15jn _18u0v77o _1s6jaq80",
    enableRightSidebar: "_1bsbsul6",
    nav4Enabled: "_1bsb1osq _18u0ze3t",
    addMinWidth: "_1ul9cv93"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_1e0cglyw _1pby1ial _1bsb1osq _kqsw1n9t _bfhkvuon _1ltv1d4h _p12f18ua",
    showPanel: "_1e0c1ule",
    isFullWidth: "_1ltvidpf _p12fglyw"
};
const $4e0d0b830c02a893$var$floatingNoteFixedWrapperStyles = {
    default: "_1pby9y44 _kqsw1n9t _1bsbsul6 _4t3i1osq _lcxvglyw"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$export$80006b81bf20e108 = ({ enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isPdfExport = typeof window !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, isFullWidth: isFullWidth, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, isForgePageBannerFullWidth: isForgePageBannerFullWidth, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, isNav4Enabled, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const topElementStyle = {};
    if (screen) {
        for (const key of Object.keys(screen))if (key.startsWith('background')) {
            const value = screen[key];
            if ((0, $6mKj3.expValEquals)('confluence_frontend_fix_content_body_compiled', 'isEnabled', true)) // Use CSS variables to prevent attribute mutations from empty values
            {
                if (Boolean(screen.background?.trim())) {
                    const variableName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
                    topElementStyle[variableName] = value;
                }
            } else topElementStyle[key] = screen[key];
        }
    }
    (0, $42omo.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isNav4Enabled && isFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1wzo"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isNav4Enabled && isForgePageBannerFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3irbkl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" /*
         * Previously, this used to be a `<Global styles={[…]} />` from Emotion, GlobalImagePreviewStyling
         * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
         */ , {
        // TODO: remove this when confluence-previews no longer used
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            enableRightSidebarCSS && $4e0d0b830c02a893$var$mainContentContainerStyles['enableRightSidebar'],
            isNav4Enabled && $4e0d0b830c02a893$var$mainContentContainerStyles['nav4Enabled'],
            $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, (0, $6mKj3.expVal)('cc_notes', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "main-layout-notes-fixed-container",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$floatingNoteFixedWrapperStyles.default
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $727a4bb7ae4ee699$export$1584143957275f3b), null)), shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_16jlidpf _1o9zkb7n _i0dl1wug _19pkidpf _vchhusvi _11rm1hrf _kqswh2mm _1bsb1osq _1e0c1txw _1tken7od"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle
        }, children))), !isEdit && !isLivePage && !ommitComponentsNotNeededForPdfExport && ((0, $6mKj3.expVal)('confluence_frontend_atl_footer_hydration_fix', 'isEnabled', false) ? !renderServerPlaceholder : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)))) : null;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $42omo.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $42omo.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hDG7z.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $9wGTI.fg)('cfe_use_confluence_relay_env') ? (0, $9HB34.getRelayEnvironment)() : $4e0d0b830c02a893$export$7292bf0b169ba997
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content));
    return content;
};


const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $42omo.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode}}}}}`, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_recentDropdown"] = $35b50a968705ed01$export$1a3cc5086fadf289;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("hDG7z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $cgEsw = parcelRequire("cgEsw");


var $jbuqY = parcelRequire("jbuqY");

const $c8aadc7c03a52230$export$6d1402fb58384e4f = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t0;
    if ($[0] !== isNav4Enabled || $[1] !== props) {
        t0 = isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
        $[0] = isNav4Enabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
};
module.exports["PageLayout"] = $c8aadc7c03a52230$export$6d1402fb58384e4f;

});

parcelRegister("cgEsw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf3be568142fa4d$export$25b68ac96f2af713 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y6119",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("jDNhm"))).PageLayout
});
module.exports["Nav4Layout"] = $acf3be568142fa4d$export$25b68ac96f2af713;

});

parcelRegister("jDNhm", function(module, exports) {

let $e4c7e2a513492843$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4c7e2a513492843$var$load("h3ABO"),
    $e4c7e2a513492843$var$load("607sQ"),
    $e4c7e2a513492843$var$load("4USmq"),
    $e4c7e2a513492843$var$load("kAAjo"),
    $e4c7e2a513492843$var$load("fbRdC"),
    $e4c7e2a513492843$var$load("jyfIr"),
    $e4c7e2a513492843$var$load("k8XPW"),
    $e4c7e2a513492843$var$load("fWCRm"),
    $e4c7e2a513492843$var$load("jTaSF"),
    $e4c7e2a513492843$var$load("7WaUI"),
    $e4c7e2a513492843$var$load("3Kg3S"),
    $e4c7e2a513492843$var$load("5rrJ1"),
    $e4c7e2a513492843$var$load("35v4f"),
    $e4c7e2a513492843$var$load("ix2PC"),
    $e4c7e2a513492843$var$load("9GMEV"),
    $e4c7e2a513492843$var$load("idou7"),
    $e4c7e2a513492843$var$load("84LYM"),
    $e4c7e2a513492843$var$load("1aPQ5"),
    $e4c7e2a513492843$var$load("iVOZI"),
    $e4c7e2a513492843$var$load("2U7sd"),
    $e4c7e2a513492843$var$load("edyLn"),
    $e4c7e2a513492843$var$load("6tsCm"),
    $e4c7e2a513492843$var$load("1djk4"),
    $e4c7e2a513492843$var$load("ko0oH"),
    $e4c7e2a513492843$var$load("gLGsg"),
    $e4c7e2a513492843$var$load("jvHRs"),
    $e4c7e2a513492843$var$load("dChec"),
    $e4c7e2a513492843$var$load("9XYQ9"),
    $e4c7e2a513492843$var$load("cfK8L"),
    $e4c7e2a513492843$var$load("1qlDN"),
    $e4c7e2a513492843$var$load("1yVM6"),
    $e4c7e2a513492843$var$load("kCgIf"),
    $e4c7e2a513492843$var$load("aeEUI"),
    $e4c7e2a513492843$var$load("eY3St"),
    $e4c7e2a513492843$var$load("bkd4T"),
    $e4c7e2a513492843$var$load("awqCy"),
    $e4c7e2a513492843$var$load("6wr18"),
    $e4c7e2a513492843$var$load("kjZZD"),
    $e4c7e2a513492843$var$load("fZt2F"),
    $e4c7e2a513492843$var$load("cStLv"),
    $e4c7e2a513492843$var$load("8jijB"),
    $e4c7e2a513492843$var$load("7u4WP"),
    $e4c7e2a513492843$var$load("Wowvf"),
    $e4c7e2a513492843$var$load("ffEVr"),
    $e4c7e2a513492843$var$load("jlSv2"),
    $e4c7e2a513492843$var$load("1UUrt"),
    $e4c7e2a513492843$var$load("amUNi"),
    $e4c7e2a513492843$var$load("d6s42"),
    $e4c7e2a513492843$var$load("kWZnd"),
    $e4c7e2a513492843$var$load("92LGf"),
    $e4c7e2a513492843$var$load("iqKwT"),
    $e4c7e2a513492843$var$load("kUbUu"),
    $e4c7e2a513492843$var$load("iZ4sC"),
    $e4c7e2a513492843$var$load("hhss7"),
    $e4c7e2a513492843$var$load("7EorR"),
    $e4c7e2a513492843$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("jbuqY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6f90fb0ae36f35f$export$7faac1b59c375dfa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oUMKP",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("jc2Cu"))).PageLayout
});
module.exports["Nav3Layout"] = $f6f90fb0ae36f35f$export$7faac1b59c375dfa;

});

parcelRegister("jc2Cu", function(module, exports) {

let $df912b9275146496$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $df912b9275146496$var$load("1djk4"),
    $df912b9275146496$var$load("6wr18"),
    $df912b9275146496$var$load("aWd5V"),
    $df912b9275146496$var$load("6tsCm"),
    $df912b9275146496$var$load("2F69B"),
    $df912b9275146496$var$load("fZt2F"),
    $df912b9275146496$var$load("ffEVr"),
    $df912b9275146496$var$load("jlSv2"),
    $df912b9275146496$var$load("1UUrt"),
    $df912b9275146496$var$load("amUNi"),
    $df912b9275146496$var$load("kWZnd"),
    $df912b9275146496$var$load("92LGf"),
    $df912b9275146496$var$load("iZ4sC"),
    $df912b9275146496$var$load("hhss7"),
    $df912b9275146496$var$load("h3ABO"),
    $df912b9275146496$var$load("kC80R"),
    $df912b9275146496$var$load("7EorR"),
    $df912b9275146496$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("3b6WO", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $42omo = parcelRequire("42omo");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: queryOptions,
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $7zIsq.usePrefilteredExtensionList)(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const options = t0;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t1;
    if ($[2] !== data) {
        t1 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined;
        $[2] = data;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== error || $[5] !== loading || $[6] !== t1) {
        t2 = {
            loading: loading,
            data: t1,
            error: error
        };
        $[4] = error;
        $[5] = loading;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (spaceKey)=>{
    /** @schema cc */ const useSpaceDetailQuery = (0, $4ZxLt.default);
    const options = {
        variables: {
            spaceKey: spaceKey
        }
    };
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(useSpaceDetailQuery, options);
    return {
        loading: loading,
        data: data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined,
        error: error
    };
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("jln20", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
} : ()=>(0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $42omo.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    const contextValue = (0, $42omo.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("6yagU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fN3iy = parcelRequire("fN3iy");


var $dj7jL = parcelRequire("dj7jL");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $42omo.useCallback)(()=>{
        /*
		Any time a Preview Panel is opened in Confluence, we want to close all
		non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
		*/ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $42omo.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
			Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
			next panel are different, we want to close the previous panel before opening the new one. In order to
			do this we need to pass the preview panel api
		*/ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN3iy.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $QU6QS.useLocation)();
    const previousLocation = (0, $42omo.useRef)(location);
    (0, $42omo.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $4BDAe = parcelRequire("4BDAe");

var $fN3iy = parcelRequire("fN3iy");


var $9wGTI = parcelRequire("9wGTI");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("8zMP3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $eS4vC = parcelRequire("eS4vC");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $42omo.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $42omo.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("7fOZj", function(module, exports) {

let $54817c44818bab48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $54817c44818bab48$var$load("6wr18"),
    $54817c44818bab48$var$load("kFrh6"),
    $54817c44818bab48$var$load("36naF"),
    $54817c44818bab48$var$load("9prMQ"),
    $54817c44818bab48$var$load("eMvqy"),
    $54817c44818bab48$var$load("7WcBh"),
    $54817c44818bab48$var$load("gM7lZ"),
    $54817c44818bab48$var$load("3xuDK"),
    $54817c44818bab48$var$load("2Mq3f"),
    $54817c44818bab48$var$load("gLGsg"),
    $54817c44818bab48$var$load("4drdS"),
    $54817c44818bab48$var$load("g5HUX"),
    $54817c44818bab48$var$load("R7cS6"),
    $54817c44818bab48$var$load("ffEVr"),
    $54817c44818bab48$var$load("fDmB2")
]).then(()=>parcelRequire('4GYnQ'));

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("kYJuW"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("jn4rf"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("DQbmS"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("8cail"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("3Vhzx"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("e6EZt"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("h3SsY"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("kgrnX"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("7wxUV"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("bUFBq"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("eILDk"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("gnlUi"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("kYJuW", function(module, exports) {

let $f45cb4365b40fb2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f45cb4365b40fb2e$var$load("cfK8L"),
    $f45cb4365b40fb2e$var$load("2YffH"),
    $f45cb4365b40fb2e$var$load("8Kivm"),
    $f45cb4365b40fb2e$var$load("aT7sf"),
    $f45cb4365b40fb2e$var$load("fRvqe"),
    $f45cb4365b40fb2e$var$load("iQ0Jm"),
    $f45cb4365b40fb2e$var$load("ev7SX"),
    $f45cb4365b40fb2e$var$load("9w0Re"),
    $f45cb4365b40fb2e$var$load("1wQU1"),
    $f45cb4365b40fb2e$var$load("h4Nf7"),
    $f45cb4365b40fb2e$var$load("7f9Fz"),
    $f45cb4365b40fb2e$var$load("8YSo7"),
    $f45cb4365b40fb2e$var$load("lYvov"),
    $f45cb4365b40fb2e$var$load("k8XPW"),
    $f45cb4365b40fb2e$var$load("fWCRm"),
    $f45cb4365b40fb2e$var$load("g9CVe"),
    $f45cb4365b40fb2e$var$load("aeEUI"),
    $f45cb4365b40fb2e$var$load("eY3St"),
    $f45cb4365b40fb2e$var$load("bkd4T"),
    $f45cb4365b40fb2e$var$load("awqCy"),
    $f45cb4365b40fb2e$var$load("6wr18"),
    $f45cb4365b40fb2e$var$load("kjZZD"),
    $f45cb4365b40fb2e$var$load("3ySTn"),
    $f45cb4365b40fb2e$var$load("c2rHL"),
    $f45cb4365b40fb2e$var$load("kHOMt"),
    $f45cb4365b40fb2e$var$load("hhss7"),
    $f45cb4365b40fb2e$var$load("cB5rV"),
    $f45cb4365b40fb2e$var$load("aKnnM"),
    $f45cb4365b40fb2e$var$load("iZU4p"),
    $f45cb4365b40fb2e$var$load("Wowvf"),
    $f45cb4365b40fb2e$var$load("ffEVr"),
    $f45cb4365b40fb2e$var$load("jlSv2"),
    $f45cb4365b40fb2e$var$load("1UUrt"),
    $f45cb4365b40fb2e$var$load("kAAjo"),
    $f45cb4365b40fb2e$var$load("fbRdC"),
    $f45cb4365b40fb2e$var$load("kWZnd"),
    $f45cb4365b40fb2e$var$load("92LGf"),
    $f45cb4365b40fb2e$var$load("iqKwT"),
    $f45cb4365b40fb2e$var$load("jyfIr"),
    $f45cb4365b40fb2e$var$load("9IeAj"),
    $f45cb4365b40fb2e$var$load("kUbUu"),
    $f45cb4365b40fb2e$var$load("2PePB"),
    $f45cb4365b40fb2e$var$load("lnKog"),
    $f45cb4365b40fb2e$var$load("9ftJe"),
    $f45cb4365b40fb2e$var$load("h3ABO"),
    $f45cb4365b40fb2e$var$load("kC80R"),
    $f45cb4365b40fb2e$var$load("7EorR"),
    $f45cb4365b40fb2e$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("jn4rf", function(module, exports) {

let $e1a39bb12e4807d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1a39bb12e4807d1$var$load("cfK8L"),
    $e1a39bb12e4807d1$var$load("2YffH"),
    $e1a39bb12e4807d1$var$load("8Kivm"),
    $e1a39bb12e4807d1$var$load("aT7sf"),
    $e1a39bb12e4807d1$var$load("fRvqe"),
    $e1a39bb12e4807d1$var$load("iQ0Jm"),
    $e1a39bb12e4807d1$var$load("ev7SX"),
    $e1a39bb12e4807d1$var$load("9w0Re"),
    $e1a39bb12e4807d1$var$load("1wQU1"),
    $e1a39bb12e4807d1$var$load("h4Nf7"),
    $e1a39bb12e4807d1$var$load("7f9Fz"),
    $e1a39bb12e4807d1$var$load("8YSo7"),
    $e1a39bb12e4807d1$var$load("lYvov"),
    $e1a39bb12e4807d1$var$load("k8XPW"),
    $e1a39bb12e4807d1$var$load("fWCRm"),
    $e1a39bb12e4807d1$var$load("g9CVe"),
    $e1a39bb12e4807d1$var$load("aeEUI"),
    $e1a39bb12e4807d1$var$load("eY3St"),
    $e1a39bb12e4807d1$var$load("bkd4T"),
    $e1a39bb12e4807d1$var$load("awqCy"),
    $e1a39bb12e4807d1$var$load("6wr18"),
    $e1a39bb12e4807d1$var$load("kjZZD"),
    $e1a39bb12e4807d1$var$load("3ySTn"),
    $e1a39bb12e4807d1$var$load("c2rHL"),
    $e1a39bb12e4807d1$var$load("kHOMt"),
    $e1a39bb12e4807d1$var$load("hhss7"),
    $e1a39bb12e4807d1$var$load("cB5rV"),
    $e1a39bb12e4807d1$var$load("aKnnM"),
    $e1a39bb12e4807d1$var$load("iZU4p"),
    $e1a39bb12e4807d1$var$load("Wowvf"),
    $e1a39bb12e4807d1$var$load("ffEVr"),
    $e1a39bb12e4807d1$var$load("jlSv2"),
    $e1a39bb12e4807d1$var$load("1UUrt"),
    $e1a39bb12e4807d1$var$load("kAAjo"),
    $e1a39bb12e4807d1$var$load("fbRdC"),
    $e1a39bb12e4807d1$var$load("kWZnd"),
    $e1a39bb12e4807d1$var$load("92LGf"),
    $e1a39bb12e4807d1$var$load("iqKwT"),
    $e1a39bb12e4807d1$var$load("jyfIr"),
    $e1a39bb12e4807d1$var$load("9IeAj"),
    $e1a39bb12e4807d1$var$load("kUbUu"),
    $e1a39bb12e4807d1$var$load("2PePB"),
    $e1a39bb12e4807d1$var$load("lnKog"),
    $e1a39bb12e4807d1$var$load("9ftJe"),
    $e1a39bb12e4807d1$var$load("h3ABO"),
    $e1a39bb12e4807d1$var$load("kC80R"),
    $e1a39bb12e4807d1$var$load("7EorR"),
    $e1a39bb12e4807d1$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("DQbmS", function(module, exports) {

let $077c1ef61f22fb4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $077c1ef61f22fb4a$var$load("cfK8L"),
    $077c1ef61f22fb4a$var$load("2YffH"),
    $077c1ef61f22fb4a$var$load("8Kivm"),
    $077c1ef61f22fb4a$var$load("aT7sf"),
    $077c1ef61f22fb4a$var$load("fRvqe"),
    $077c1ef61f22fb4a$var$load("iQ0Jm"),
    $077c1ef61f22fb4a$var$load("ev7SX"),
    $077c1ef61f22fb4a$var$load("9w0Re"),
    $077c1ef61f22fb4a$var$load("1wQU1"),
    $077c1ef61f22fb4a$var$load("h4Nf7"),
    $077c1ef61f22fb4a$var$load("7f9Fz"),
    $077c1ef61f22fb4a$var$load("8YSo7"),
    $077c1ef61f22fb4a$var$load("lYvov"),
    $077c1ef61f22fb4a$var$load("k8XPW"),
    $077c1ef61f22fb4a$var$load("fWCRm"),
    $077c1ef61f22fb4a$var$load("g9CVe"),
    $077c1ef61f22fb4a$var$load("aeEUI"),
    $077c1ef61f22fb4a$var$load("eY3St"),
    $077c1ef61f22fb4a$var$load("bkd4T"),
    $077c1ef61f22fb4a$var$load("awqCy"),
    $077c1ef61f22fb4a$var$load("6wr18"),
    $077c1ef61f22fb4a$var$load("kjZZD"),
    $077c1ef61f22fb4a$var$load("3ySTn"),
    $077c1ef61f22fb4a$var$load("c2rHL"),
    $077c1ef61f22fb4a$var$load("kHOMt"),
    $077c1ef61f22fb4a$var$load("hhss7"),
    $077c1ef61f22fb4a$var$load("cB5rV"),
    $077c1ef61f22fb4a$var$load("aKnnM"),
    $077c1ef61f22fb4a$var$load("iZU4p"),
    $077c1ef61f22fb4a$var$load("Wowvf"),
    $077c1ef61f22fb4a$var$load("ffEVr"),
    $077c1ef61f22fb4a$var$load("jlSv2"),
    $077c1ef61f22fb4a$var$load("1UUrt"),
    $077c1ef61f22fb4a$var$load("kAAjo"),
    $077c1ef61f22fb4a$var$load("fbRdC"),
    $077c1ef61f22fb4a$var$load("kWZnd"),
    $077c1ef61f22fb4a$var$load("92LGf"),
    $077c1ef61f22fb4a$var$load("iqKwT"),
    $077c1ef61f22fb4a$var$load("jyfIr"),
    $077c1ef61f22fb4a$var$load("9IeAj"),
    $077c1ef61f22fb4a$var$load("kUbUu"),
    $077c1ef61f22fb4a$var$load("2PePB"),
    $077c1ef61f22fb4a$var$load("lnKog"),
    $077c1ef61f22fb4a$var$load("9ftJe"),
    $077c1ef61f22fb4a$var$load("h3ABO"),
    $077c1ef61f22fb4a$var$load("kC80R"),
    $077c1ef61f22fb4a$var$load("7EorR"),
    $077c1ef61f22fb4a$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("8cail", function(module, exports) {

let $5f776e176e3dfb7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f776e176e3dfb7f$var$load("cfK8L"),
    $5f776e176e3dfb7f$var$load("k8XPW"),
    $5f776e176e3dfb7f$var$load("fWCRm"),
    $5f776e176e3dfb7f$var$load("2YffH"),
    $5f776e176e3dfb7f$var$load("2PePB"),
    $5f776e176e3dfb7f$var$load("aT7sf"),
    $5f776e176e3dfb7f$var$load("fRvqe"),
    $5f776e176e3dfb7f$var$load("9w0Re"),
    $5f776e176e3dfb7f$var$load("1wQU1"),
    $5f776e176e3dfb7f$var$load("h4Nf7"),
    $5f776e176e3dfb7f$var$load("7f9Fz"),
    $5f776e176e3dfb7f$var$load("8YSo7"),
    $5f776e176e3dfb7f$var$load("lYvov"),
    $5f776e176e3dfb7f$var$load("g9CVe"),
    $5f776e176e3dfb7f$var$load("aeEUI"),
    $5f776e176e3dfb7f$var$load("eY3St"),
    $5f776e176e3dfb7f$var$load("bkd4T"),
    $5f776e176e3dfb7f$var$load("awqCy"),
    $5f776e176e3dfb7f$var$load("6wr18"),
    $5f776e176e3dfb7f$var$load("kjZZD"),
    $5f776e176e3dfb7f$var$load("3ySTn"),
    $5f776e176e3dfb7f$var$load("c2rHL"),
    $5f776e176e3dfb7f$var$load("kHOMt"),
    $5f776e176e3dfb7f$var$load("hhss7"),
    $5f776e176e3dfb7f$var$load("cB5rV"),
    $5f776e176e3dfb7f$var$load("aKnnM"),
    $5f776e176e3dfb7f$var$load("iZU4p"),
    $5f776e176e3dfb7f$var$load("Wowvf"),
    $5f776e176e3dfb7f$var$load("ffEVr"),
    $5f776e176e3dfb7f$var$load("jlSv2"),
    $5f776e176e3dfb7f$var$load("1UUrt"),
    $5f776e176e3dfb7f$var$load("kAAjo"),
    $5f776e176e3dfb7f$var$load("fbRdC"),
    $5f776e176e3dfb7f$var$load("kWZnd"),
    $5f776e176e3dfb7f$var$load("92LGf"),
    $5f776e176e3dfb7f$var$load("iqKwT"),
    $5f776e176e3dfb7f$var$load("jyfIr"),
    $5f776e176e3dfb7f$var$load("9IeAj"),
    $5f776e176e3dfb7f$var$load("kUbUu"),
    $5f776e176e3dfb7f$var$load("9ftJe"),
    $5f776e176e3dfb7f$var$load("h3ABO"),
    $5f776e176e3dfb7f$var$load("kC80R"),
    $5f776e176e3dfb7f$var$load("7EorR"),
    $5f776e176e3dfb7f$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("3Vhzx", function(module, exports) {

let $2db453703e01dafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2db453703e01dafa$var$load("cfK8L"),
    $2db453703e01dafa$var$load("k8XPW"),
    $2db453703e01dafa$var$load("fWCRm"),
    $2db453703e01dafa$var$load("2YffH"),
    $2db453703e01dafa$var$load("2PePB"),
    $2db453703e01dafa$var$load("aT7sf"),
    $2db453703e01dafa$var$load("fRvqe"),
    $2db453703e01dafa$var$load("9w0Re"),
    $2db453703e01dafa$var$load("1wQU1"),
    $2db453703e01dafa$var$load("h4Nf7"),
    $2db453703e01dafa$var$load("7f9Fz"),
    $2db453703e01dafa$var$load("8YSo7"),
    $2db453703e01dafa$var$load("lYvov"),
    $2db453703e01dafa$var$load("g9CVe"),
    $2db453703e01dafa$var$load("aeEUI"),
    $2db453703e01dafa$var$load("eY3St"),
    $2db453703e01dafa$var$load("bkd4T"),
    $2db453703e01dafa$var$load("awqCy"),
    $2db453703e01dafa$var$load("6wr18"),
    $2db453703e01dafa$var$load("kjZZD"),
    $2db453703e01dafa$var$load("3ySTn"),
    $2db453703e01dafa$var$load("c2rHL"),
    $2db453703e01dafa$var$load("kHOMt"),
    $2db453703e01dafa$var$load("hhss7"),
    $2db453703e01dafa$var$load("cB5rV"),
    $2db453703e01dafa$var$load("aKnnM"),
    $2db453703e01dafa$var$load("iZU4p"),
    $2db453703e01dafa$var$load("Wowvf"),
    $2db453703e01dafa$var$load("ffEVr"),
    $2db453703e01dafa$var$load("jlSv2"),
    $2db453703e01dafa$var$load("1UUrt"),
    $2db453703e01dafa$var$load("kAAjo"),
    $2db453703e01dafa$var$load("fbRdC"),
    $2db453703e01dafa$var$load("kWZnd"),
    $2db453703e01dafa$var$load("92LGf"),
    $2db453703e01dafa$var$load("iqKwT"),
    $2db453703e01dafa$var$load("jyfIr"),
    $2db453703e01dafa$var$load("9IeAj"),
    $2db453703e01dafa$var$load("kUbUu"),
    $2db453703e01dafa$var$load("9ftJe"),
    $2db453703e01dafa$var$load("h3ABO"),
    $2db453703e01dafa$var$load("kC80R"),
    $2db453703e01dafa$var$load("7EorR"),
    $2db453703e01dafa$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("e6EZt", function(module, exports) {

let $a4516c1c46ddc101$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a4516c1c46ddc101$var$load("cfK8L"),
    $a4516c1c46ddc101$var$load("k8XPW"),
    $a4516c1c46ddc101$var$load("fWCRm"),
    $a4516c1c46ddc101$var$load("2YffH"),
    $a4516c1c46ddc101$var$load("2PePB"),
    $a4516c1c46ddc101$var$load("aT7sf"),
    $a4516c1c46ddc101$var$load("fRvqe"),
    $a4516c1c46ddc101$var$load("9w0Re"),
    $a4516c1c46ddc101$var$load("1wQU1"),
    $a4516c1c46ddc101$var$load("h4Nf7"),
    $a4516c1c46ddc101$var$load("7f9Fz"),
    $a4516c1c46ddc101$var$load("8YSo7"),
    $a4516c1c46ddc101$var$load("lYvov"),
    $a4516c1c46ddc101$var$load("g9CVe"),
    $a4516c1c46ddc101$var$load("aeEUI"),
    $a4516c1c46ddc101$var$load("eY3St"),
    $a4516c1c46ddc101$var$load("bkd4T"),
    $a4516c1c46ddc101$var$load("awqCy"),
    $a4516c1c46ddc101$var$load("6wr18"),
    $a4516c1c46ddc101$var$load("kjZZD"),
    $a4516c1c46ddc101$var$load("3ySTn"),
    $a4516c1c46ddc101$var$load("c2rHL"),
    $a4516c1c46ddc101$var$load("kHOMt"),
    $a4516c1c46ddc101$var$load("hhss7"),
    $a4516c1c46ddc101$var$load("cB5rV"),
    $a4516c1c46ddc101$var$load("aKnnM"),
    $a4516c1c46ddc101$var$load("iZU4p"),
    $a4516c1c46ddc101$var$load("Wowvf"),
    $a4516c1c46ddc101$var$load("ffEVr"),
    $a4516c1c46ddc101$var$load("jlSv2"),
    $a4516c1c46ddc101$var$load("1UUrt"),
    $a4516c1c46ddc101$var$load("kAAjo"),
    $a4516c1c46ddc101$var$load("fbRdC"),
    $a4516c1c46ddc101$var$load("kWZnd"),
    $a4516c1c46ddc101$var$load("92LGf"),
    $a4516c1c46ddc101$var$load("iqKwT"),
    $a4516c1c46ddc101$var$load("jyfIr"),
    $a4516c1c46ddc101$var$load("9IeAj"),
    $a4516c1c46ddc101$var$load("kUbUu"),
    $a4516c1c46ddc101$var$load("9ftJe"),
    $a4516c1c46ddc101$var$load("h3ABO"),
    $a4516c1c46ddc101$var$load("kC80R"),
    $a4516c1c46ddc101$var$load("7EorR"),
    $a4516c1c46ddc101$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("h3SsY", function(module, exports) {

let $c6bcf75774f95e07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6bcf75774f95e07$var$load("cfK8L"),
    $c6bcf75774f95e07$var$load("k8XPW"),
    $c6bcf75774f95e07$var$load("fWCRm"),
    $c6bcf75774f95e07$var$load("2YffH"),
    $c6bcf75774f95e07$var$load("aT7sf"),
    $c6bcf75774f95e07$var$load("fRvqe"),
    $c6bcf75774f95e07$var$load("9w0Re"),
    $c6bcf75774f95e07$var$load("1wQU1"),
    $c6bcf75774f95e07$var$load("h4Nf7"),
    $c6bcf75774f95e07$var$load("7f9Fz"),
    $c6bcf75774f95e07$var$load("8YSo7"),
    $c6bcf75774f95e07$var$load("lYvov"),
    $c6bcf75774f95e07$var$load("g9CVe"),
    $c6bcf75774f95e07$var$load("aeEUI"),
    $c6bcf75774f95e07$var$load("eY3St"),
    $c6bcf75774f95e07$var$load("bkd4T"),
    $c6bcf75774f95e07$var$load("awqCy"),
    $c6bcf75774f95e07$var$load("6wr18"),
    $c6bcf75774f95e07$var$load("kjZZD"),
    $c6bcf75774f95e07$var$load("3ySTn"),
    $c6bcf75774f95e07$var$load("c2rHL"),
    $c6bcf75774f95e07$var$load("kHOMt"),
    $c6bcf75774f95e07$var$load("hhss7"),
    $c6bcf75774f95e07$var$load("cB5rV"),
    $c6bcf75774f95e07$var$load("aKnnM"),
    $c6bcf75774f95e07$var$load("iZU4p"),
    $c6bcf75774f95e07$var$load("Wowvf"),
    $c6bcf75774f95e07$var$load("ffEVr"),
    $c6bcf75774f95e07$var$load("jlSv2"),
    $c6bcf75774f95e07$var$load("1UUrt"),
    $c6bcf75774f95e07$var$load("kAAjo"),
    $c6bcf75774f95e07$var$load("fbRdC"),
    $c6bcf75774f95e07$var$load("kWZnd"),
    $c6bcf75774f95e07$var$load("92LGf"),
    $c6bcf75774f95e07$var$load("iqKwT"),
    $c6bcf75774f95e07$var$load("jyfIr"),
    $c6bcf75774f95e07$var$load("9IeAj"),
    $c6bcf75774f95e07$var$load("kUbUu"),
    $c6bcf75774f95e07$var$load("2PePB"),
    $c6bcf75774f95e07$var$load("lnKog"),
    $c6bcf75774f95e07$var$load("9ftJe"),
    $c6bcf75774f95e07$var$load("h3ABO"),
    $c6bcf75774f95e07$var$load("kC80R"),
    $c6bcf75774f95e07$var$load("7EorR"),
    $c6bcf75774f95e07$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("kgrnX", function(module, exports) {

let $ec0a8b718ae0dffe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec0a8b718ae0dffe$var$load("cfK8L"),
    $ec0a8b718ae0dffe$var$load("2YffH"),
    $ec0a8b718ae0dffe$var$load("aT7sf"),
    $ec0a8b718ae0dffe$var$load("fRvqe"),
    $ec0a8b718ae0dffe$var$load("ev7SX"),
    $ec0a8b718ae0dffe$var$load("9w0Re"),
    $ec0a8b718ae0dffe$var$load("1wQU1"),
    $ec0a8b718ae0dffe$var$load("h4Nf7"),
    $ec0a8b718ae0dffe$var$load("7f9Fz"),
    $ec0a8b718ae0dffe$var$load("8YSo7"),
    $ec0a8b718ae0dffe$var$load("lYvov"),
    $ec0a8b718ae0dffe$var$load("k8XPW"),
    $ec0a8b718ae0dffe$var$load("fWCRm"),
    $ec0a8b718ae0dffe$var$load("g9CVe"),
    $ec0a8b718ae0dffe$var$load("aeEUI"),
    $ec0a8b718ae0dffe$var$load("eY3St"),
    $ec0a8b718ae0dffe$var$load("bkd4T"),
    $ec0a8b718ae0dffe$var$load("dTsOE"),
    $ec0a8b718ae0dffe$var$load("awqCy"),
    $ec0a8b718ae0dffe$var$load("6wr18"),
    $ec0a8b718ae0dffe$var$load("kjZZD"),
    $ec0a8b718ae0dffe$var$load("3ySTn"),
    $ec0a8b718ae0dffe$var$load("c2rHL"),
    $ec0a8b718ae0dffe$var$load("kHOMt"),
    $ec0a8b718ae0dffe$var$load("hhss7"),
    $ec0a8b718ae0dffe$var$load("cB5rV"),
    $ec0a8b718ae0dffe$var$load("aKnnM"),
    $ec0a8b718ae0dffe$var$load("iZU4p"),
    $ec0a8b718ae0dffe$var$load("Wowvf"),
    $ec0a8b718ae0dffe$var$load("ffEVr"),
    $ec0a8b718ae0dffe$var$load("jlSv2"),
    $ec0a8b718ae0dffe$var$load("1UUrt"),
    $ec0a8b718ae0dffe$var$load("kAAjo"),
    $ec0a8b718ae0dffe$var$load("fbRdC"),
    $ec0a8b718ae0dffe$var$load("kWZnd"),
    $ec0a8b718ae0dffe$var$load("92LGf"),
    $ec0a8b718ae0dffe$var$load("iqKwT"),
    $ec0a8b718ae0dffe$var$load("jyfIr"),
    $ec0a8b718ae0dffe$var$load("9IeAj"),
    $ec0a8b718ae0dffe$var$load("kUbUu"),
    $ec0a8b718ae0dffe$var$load("2PePB"),
    $ec0a8b718ae0dffe$var$load("lnKog"),
    $ec0a8b718ae0dffe$var$load("9ftJe"),
    $ec0a8b718ae0dffe$var$load("h3ABO"),
    $ec0a8b718ae0dffe$var$load("kC80R"),
    $ec0a8b718ae0dffe$var$load("7EorR"),
    $ec0a8b718ae0dffe$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("7wxUV", function(module, exports) {

let $57a5d4d03fa66778$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57a5d4d03fa66778$var$load("cfK8L"),
    $57a5d4d03fa66778$var$load("2YffH"),
    $57a5d4d03fa66778$var$load("aT7sf"),
    $57a5d4d03fa66778$var$load("fRvqe"),
    $57a5d4d03fa66778$var$load("ev7SX"),
    $57a5d4d03fa66778$var$load("9w0Re"),
    $57a5d4d03fa66778$var$load("1wQU1"),
    $57a5d4d03fa66778$var$load("h4Nf7"),
    $57a5d4d03fa66778$var$load("7f9Fz"),
    $57a5d4d03fa66778$var$load("8YSo7"),
    $57a5d4d03fa66778$var$load("lYvov"),
    $57a5d4d03fa66778$var$load("k8XPW"),
    $57a5d4d03fa66778$var$load("fWCRm"),
    $57a5d4d03fa66778$var$load("g9CVe"),
    $57a5d4d03fa66778$var$load("aeEUI"),
    $57a5d4d03fa66778$var$load("eY3St"),
    $57a5d4d03fa66778$var$load("bkd4T"),
    $57a5d4d03fa66778$var$load("dTsOE"),
    $57a5d4d03fa66778$var$load("awqCy"),
    $57a5d4d03fa66778$var$load("6wr18"),
    $57a5d4d03fa66778$var$load("kjZZD"),
    $57a5d4d03fa66778$var$load("3ySTn"),
    $57a5d4d03fa66778$var$load("c2rHL"),
    $57a5d4d03fa66778$var$load("kHOMt"),
    $57a5d4d03fa66778$var$load("hhss7"),
    $57a5d4d03fa66778$var$load("cB5rV"),
    $57a5d4d03fa66778$var$load("aKnnM"),
    $57a5d4d03fa66778$var$load("iZU4p"),
    $57a5d4d03fa66778$var$load("Wowvf"),
    $57a5d4d03fa66778$var$load("ffEVr"),
    $57a5d4d03fa66778$var$load("jlSv2"),
    $57a5d4d03fa66778$var$load("1UUrt"),
    $57a5d4d03fa66778$var$load("kAAjo"),
    $57a5d4d03fa66778$var$load("fbRdC"),
    $57a5d4d03fa66778$var$load("kWZnd"),
    $57a5d4d03fa66778$var$load("92LGf"),
    $57a5d4d03fa66778$var$load("iqKwT"),
    $57a5d4d03fa66778$var$load("jyfIr"),
    $57a5d4d03fa66778$var$load("9IeAj"),
    $57a5d4d03fa66778$var$load("kUbUu"),
    $57a5d4d03fa66778$var$load("2PePB"),
    $57a5d4d03fa66778$var$load("lnKog"),
    $57a5d4d03fa66778$var$load("9ftJe"),
    $57a5d4d03fa66778$var$load("h3ABO"),
    $57a5d4d03fa66778$var$load("kC80R"),
    $57a5d4d03fa66778$var$load("7EorR"),
    $57a5d4d03fa66778$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("bUFBq", function(module, exports) {

let $8ac53217d31a2dfa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ac53217d31a2dfa$var$load("cfK8L"),
    $8ac53217d31a2dfa$var$load("k8XPW"),
    $8ac53217d31a2dfa$var$load("fWCRm"),
    $8ac53217d31a2dfa$var$load("2YffH"),
    $8ac53217d31a2dfa$var$load("2PePB"),
    $8ac53217d31a2dfa$var$load("aT7sf"),
    $8ac53217d31a2dfa$var$load("fRvqe"),
    $8ac53217d31a2dfa$var$load("9w0Re"),
    $8ac53217d31a2dfa$var$load("1wQU1"),
    $8ac53217d31a2dfa$var$load("h4Nf7"),
    $8ac53217d31a2dfa$var$load("7f9Fz"),
    $8ac53217d31a2dfa$var$load("8YSo7"),
    $8ac53217d31a2dfa$var$load("lYvov"),
    $8ac53217d31a2dfa$var$load("g9CVe"),
    $8ac53217d31a2dfa$var$load("aeEUI"),
    $8ac53217d31a2dfa$var$load("eY3St"),
    $8ac53217d31a2dfa$var$load("bkd4T"),
    $8ac53217d31a2dfa$var$load("awqCy"),
    $8ac53217d31a2dfa$var$load("6wr18"),
    $8ac53217d31a2dfa$var$load("kjZZD"),
    $8ac53217d31a2dfa$var$load("3ySTn"),
    $8ac53217d31a2dfa$var$load("c2rHL"),
    $8ac53217d31a2dfa$var$load("kHOMt"),
    $8ac53217d31a2dfa$var$load("hhss7"),
    $8ac53217d31a2dfa$var$load("cB5rV"),
    $8ac53217d31a2dfa$var$load("aKnnM"),
    $8ac53217d31a2dfa$var$load("iZU4p"),
    $8ac53217d31a2dfa$var$load("Wowvf"),
    $8ac53217d31a2dfa$var$load("ffEVr"),
    $8ac53217d31a2dfa$var$load("jlSv2"),
    $8ac53217d31a2dfa$var$load("1UUrt"),
    $8ac53217d31a2dfa$var$load("kAAjo"),
    $8ac53217d31a2dfa$var$load("fbRdC"),
    $8ac53217d31a2dfa$var$load("kWZnd"),
    $8ac53217d31a2dfa$var$load("92LGf"),
    $8ac53217d31a2dfa$var$load("iqKwT"),
    $8ac53217d31a2dfa$var$load("jyfIr"),
    $8ac53217d31a2dfa$var$load("9IeAj"),
    $8ac53217d31a2dfa$var$load("kUbUu"),
    $8ac53217d31a2dfa$var$load("9ftJe"),
    $8ac53217d31a2dfa$var$load("h3ABO"),
    $8ac53217d31a2dfa$var$load("kC80R"),
    $8ac53217d31a2dfa$var$load("7EorR"),
    $8ac53217d31a2dfa$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("eILDk", function(module, exports) {

let $ab7a1fb8ddf30cd5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab7a1fb8ddf30cd5$var$load("cfK8L"),
    $ab7a1fb8ddf30cd5$var$load("k8XPW"),
    $ab7a1fb8ddf30cd5$var$load("fWCRm"),
    $ab7a1fb8ddf30cd5$var$load("2YffH"),
    $ab7a1fb8ddf30cd5$var$load("aT7sf"),
    $ab7a1fb8ddf30cd5$var$load("fRvqe"),
    $ab7a1fb8ddf30cd5$var$load("9w0Re"),
    $ab7a1fb8ddf30cd5$var$load("1wQU1"),
    $ab7a1fb8ddf30cd5$var$load("h4Nf7"),
    $ab7a1fb8ddf30cd5$var$load("7f9Fz"),
    $ab7a1fb8ddf30cd5$var$load("8YSo7"),
    $ab7a1fb8ddf30cd5$var$load("lYvov"),
    $ab7a1fb8ddf30cd5$var$load("g9CVe"),
    $ab7a1fb8ddf30cd5$var$load("aeEUI"),
    $ab7a1fb8ddf30cd5$var$load("eY3St"),
    $ab7a1fb8ddf30cd5$var$load("bkd4T"),
    $ab7a1fb8ddf30cd5$var$load("awqCy"),
    $ab7a1fb8ddf30cd5$var$load("6wr18"),
    $ab7a1fb8ddf30cd5$var$load("kjZZD"),
    $ab7a1fb8ddf30cd5$var$load("3ySTn"),
    $ab7a1fb8ddf30cd5$var$load("c2rHL"),
    $ab7a1fb8ddf30cd5$var$load("kHOMt"),
    $ab7a1fb8ddf30cd5$var$load("hhss7"),
    $ab7a1fb8ddf30cd5$var$load("cB5rV"),
    $ab7a1fb8ddf30cd5$var$load("aKnnM"),
    $ab7a1fb8ddf30cd5$var$load("iZU4p"),
    $ab7a1fb8ddf30cd5$var$load("Wowvf"),
    $ab7a1fb8ddf30cd5$var$load("ffEVr"),
    $ab7a1fb8ddf30cd5$var$load("jlSv2"),
    $ab7a1fb8ddf30cd5$var$load("1UUrt"),
    $ab7a1fb8ddf30cd5$var$load("kAAjo"),
    $ab7a1fb8ddf30cd5$var$load("fbRdC"),
    $ab7a1fb8ddf30cd5$var$load("kWZnd"),
    $ab7a1fb8ddf30cd5$var$load("92LGf"),
    $ab7a1fb8ddf30cd5$var$load("iqKwT"),
    $ab7a1fb8ddf30cd5$var$load("jyfIr"),
    $ab7a1fb8ddf30cd5$var$load("9IeAj"),
    $ab7a1fb8ddf30cd5$var$load("kUbUu"),
    $ab7a1fb8ddf30cd5$var$load("2PePB"),
    $ab7a1fb8ddf30cd5$var$load("lnKog"),
    $ab7a1fb8ddf30cd5$var$load("9ftJe"),
    $ab7a1fb8ddf30cd5$var$load("h3ABO"),
    $ab7a1fb8ddf30cd5$var$load("kC80R"),
    $ab7a1fb8ddf30cd5$var$load("7EorR"),
    $ab7a1fb8ddf30cd5$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("gnlUi", function(module, exports) {

let $bebfc99d15291db6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bebfc99d15291db6$var$load("cfK8L"),
    $bebfc99d15291db6$var$load("k8XPW"),
    $bebfc99d15291db6$var$load("fWCRm"),
    $bebfc99d15291db6$var$load("2YffH"),
    $bebfc99d15291db6$var$load("aT7sf"),
    $bebfc99d15291db6$var$load("fRvqe"),
    $bebfc99d15291db6$var$load("9w0Re"),
    $bebfc99d15291db6$var$load("1wQU1"),
    $bebfc99d15291db6$var$load("h4Nf7"),
    $bebfc99d15291db6$var$load("7f9Fz"),
    $bebfc99d15291db6$var$load("8YSo7"),
    $bebfc99d15291db6$var$load("lYvov"),
    $bebfc99d15291db6$var$load("g9CVe"),
    $bebfc99d15291db6$var$load("aeEUI"),
    $bebfc99d15291db6$var$load("eY3St"),
    $bebfc99d15291db6$var$load("bkd4T"),
    $bebfc99d15291db6$var$load("awqCy"),
    $bebfc99d15291db6$var$load("6wr18"),
    $bebfc99d15291db6$var$load("kjZZD"),
    $bebfc99d15291db6$var$load("3ySTn"),
    $bebfc99d15291db6$var$load("c2rHL"),
    $bebfc99d15291db6$var$load("kHOMt"),
    $bebfc99d15291db6$var$load("hhss7"),
    $bebfc99d15291db6$var$load("cB5rV"),
    $bebfc99d15291db6$var$load("aKnnM"),
    $bebfc99d15291db6$var$load("iZU4p"),
    $bebfc99d15291db6$var$load("Wowvf"),
    $bebfc99d15291db6$var$load("ffEVr"),
    $bebfc99d15291db6$var$load("jlSv2"),
    $bebfc99d15291db6$var$load("1UUrt"),
    $bebfc99d15291db6$var$load("kAAjo"),
    $bebfc99d15291db6$var$load("fbRdC"),
    $bebfc99d15291db6$var$load("kWZnd"),
    $bebfc99d15291db6$var$load("92LGf"),
    $bebfc99d15291db6$var$load("iqKwT"),
    $bebfc99d15291db6$var$load("jyfIr"),
    $bebfc99d15291db6$var$load("9IeAj"),
    $bebfc99d15291db6$var$load("kUbUu"),
    $bebfc99d15291db6$var$load("2PePB"),
    $bebfc99d15291db6$var$load("lnKog"),
    $bebfc99d15291db6$var$load("9ftJe"),
    $bebfc99d15291db6$var$load("h3ABO"),
    $bebfc99d15291db6$var$load("kC80R"),
    $bebfc99d15291db6$var$load("7EorR"),
    $bebfc99d15291db6$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.5cbb2a70.js.map
